// extracted by mini-css-extract-plugin
export var icon = "_s4-0";